import {
  Button,
  createTableColumn, DataGrid,
  DataGridBody, DataGridCell,
  DataGridHeader,
  DataGridHeaderCell,
  DataGridRow,
  Menu, MenuItem, MenuList, MenuPopover, MenuTrigger,
  TableColumnDefinition
} from '@fluentui/react-components';
import { DeleteRegular, MoreHorizontalFilled, ArrowDownRegular, EditRegular, ArrowUpRegular } from '@fluentui/react-icons';
import React from "react";
import { useIntl } from "react-intl";

import { IAppFeaturesActivityDataGrid as ITableItems } from "./IAppFeaturesActivityDataGrid"

export const AppFeaturesActivityDataGrid: React.FC<{
  onEdit: (index: number) => void,
  onDelete: (index: number) => void,
  items: ITableItems[]
}> = ({ items, onEdit, onDelete }) => {

  const intl = useIntl();

  const columns: TableColumnDefinition<ITableItems>[] = [
    createTableColumn<ITableItems>({
      columnId: "type",
      renderHeaderCell: () => intl.formatMessage({ defaultMessage: "Activity identifier" }),
      renderCell: (data) => data.type
    }),
    createTableColumn<ITableItems>({
      columnId: "description",
      renderHeaderCell: () => intl.formatMessage({ defaultMessage: "Description" }),
      renderCell: (data) => data.description
    }),
    createTableColumn<ITableItems>({
      columnId: "templateText",
      renderHeaderCell: () => intl.formatMessage({ defaultMessage: "Message template" }),
      renderCell: (data) => data.templateText
    }),
    createTableColumn<ITableItems>({
      columnId: "action",
      renderHeaderCell: () => intl.formatMessage({ defaultMessage: "Action" }),
      renderCell: (data) => <Elipsis item={data} />
    }),
  ]

  const Elipsis: React.FC<{ item: ITableItems; }> = ({ item }) => {
    return (
      <Menu>
        <MenuTrigger disableButtonEnhancement>
          <Button icon={<MoreHorizontalFilled />} appearance="transparent" />
        </MenuTrigger>
        <MenuPopover>
          <MenuList>
            <MenuItem icon={<EditRegular />} onClick={() => { onEdit(item.index) }}>
              {intl.formatMessage({ defaultMessage: "Edit" })}
            </MenuItem>
            <MenuItem icon={<DeleteRegular />} onClick={() => { onDelete(item.index) }}>
              {intl.formatMessage({ defaultMessage: "Delete" })}
            </MenuItem>
          </MenuList>
        </MenuPopover>
      </Menu>
    )
  }

  return (
    <DataGrid items={items} columns={columns} focusMode='composite'>
      <DataGridHeader>
        <DataGridRow>
          {({ renderHeaderCell }) => <DataGridHeaderCell>{renderHeaderCell()}</DataGridHeaderCell>}
        </DataGridRow>
      </DataGridHeader>
      <DataGridBody<ITableItems>>
        {({ item, rowId }) => (
          <DataGridRow<ITableItems> key={rowId}>
            {({ renderCell }) => <DataGridCell>{renderCell(item)}</DataGridCell>}
          </DataGridRow>
        )}
      </DataGridBody>
    </DataGrid>
  )
}